module.exports = __webpack_public_path__ + "media/sv_se_s1_Astrid.ada71854.mp3";